function initAccordion() {
    const accordion = document.querySelector('.js-accordion');

    if (!accordion) return;

    const items = accordion.querySelectorAll('.js-accordion-item');

    items.forEach((item) => {
        const trigger = item.querySelector('.js-accordion-trigger');

        if (!trigger) return;

        trigger.addEventListener('click', () => {
            const isOpen = item.classList.contains('is-open');

            items.forEach((otherItem) => {
                otherItem.classList.remove('is-open');
                const otherTrigger = otherItem.querySelector('.js-accordion-trigger');

                if (otherTrigger) {
                    otherTrigger.setAttribute('aria-expanded', 'false');
                }
            });

            if (!isOpen) {
                item.classList.add('is-open');
                trigger.setAttribute('aria-expanded', 'true');
            }
        });
    });
}

function initModal() {
    const modal = document.querySelector('.js-modal');

    if (!modal) return;

    const overlay = modal.querySelector('.js-modal-overlay');
    const closeBtn = modal.querySelector('.js-modal-close');
    const titleEl = modal.querySelector('.js-modal-title');
    const mediaEl = modal.querySelector('.js-modal-media');
    const ingredientsEl = modal.querySelector('.js-modal-ingredients');
    const stepsEl = modal.querySelector('.js-modal-steps');
    const scrollEl = modal.querySelector('.preserves-modal__dialog-scroll');
    const triggers = document.querySelectorAll('.js-recipe-open');

    let lastFocusedEl = null;

    function setModalTheme(theme) {
        Array.from(modal.classList).forEach((className) => {
            if (className.startsWith('preserves-modal--')) {
                modal.classList.remove(className);
            }
        });

        if (theme) {
            modal.classList.add(`preserves-modal--${theme}`);
        }
    }

    function getThemeFromTrigger(trigger) {
        const item = trigger.closest('[class*="preserves-accordion__item--"]');

        if (!item) return '';

        const match = item.className.match(/preserves-accordion__item--([a-z]+)/);

        return match ? match[1] : '';
    }

    function readCardData(trigger) {
        const body = trigger.querySelector('.preserves-recipe-card__body');

        if (!body) {
            return {
                title: '',
                media: '',
                ingredients: '',
                steps: '',
            };
        }

        const titleNode = body.querySelector('.preserves-recipe-card__title');
        const mediaNode = body.querySelector('.preserves-recipe-card__modal-media');
        const ingredientsNode = body.querySelector('.preserves-recipe-card__ingredients');
        const stepsNode = body.querySelector('.preserves-recipe-card__steps');

        return {
            title: titleNode ? titleNode.textContent.trim() : '',
            media: mediaNode ? mediaNode.innerHTML : '',
            ingredients: ingredientsNode ? ingredientsNode.innerHTML : '',
            steps: stepsNode ? stepsNode.innerHTML : '',
        };
    }

    function openModal(data) {
        lastFocusedEl = document.activeElement;

        if (titleEl) titleEl.textContent = data.title || '';
        if (mediaEl) mediaEl.innerHTML = data.media || '';
        if (ingredientsEl) ingredientsEl.innerHTML = data.ingredients || '';
        if (stepsEl) stepsEl.innerHTML = data.steps || '';
        setModalTheme(data.theme || '');

        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('is-modal-open');

        if (scrollEl) scrollEl.scrollTop = 0;
        if (closeBtn) closeBtn.focus();
    }

    function closeModal() {
        modal.classList.remove('is-open');
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('is-modal-open');

        if (lastFocusedEl && typeof lastFocusedEl.focus === 'function') {
            lastFocusedEl.focus();
        }
    }

    function handleTriggerActivate(trigger) {
        const data = readCardData(trigger);

        openModal({
            title: data.title,
            media: data.media,
            ingredients: data.ingredients,
            steps: data.steps,
            theme: getThemeFromTrigger(trigger),
        });
    }

    triggers.forEach((trigger) => {
        trigger.addEventListener('click', () => {
            handleTriggerActivate(trigger);
        });

        trigger.addEventListener('keydown', (event) => {
            if (event.key === 'Enter' || event.key === ' ') {
                event.preventDefault();
                handleTriggerActivate(trigger);
            }
        });
    });

    if (overlay) overlay.addEventListener('click', closeModal);
    if (closeBtn) closeBtn.addEventListener('click', closeModal);

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && modal.classList.contains('is-open')) {
            closeModal();
        }
    });
}


document.addEventListener('DOMContentLoaded', () => {
    initAccordion();
    initModal();
});
